import React, { useEffect, useState } from "react";
import { FaShoppingCart } from "react-icons/fa";
// import "./ImagingDetail.css";
import { useParams } from "react-router-dom";
import { getDepartmentWiseCenter, getTestList } from "../../api/api";
import CustomLoader from "../../common/loader/CustomLoader";
import CustomPagination from "../../common/CustomPagination";
import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import { FaGreaterThan } from "react-icons/fa6";
import { getDepartmentInfo } from "../../utils/helper";
import PackageDetailsModal from "../OurPackagesPageElements/PackageDetailsModel";
import { useCart } from "../../Contexts/Cart.contexts";
import toast from "react-hot-toast";
import { TruncateText } from "../../common/TruncateText";
import CenterCard from "../../common/CenterCard";

export default function HolisticDetails() {
  const [search, setSearch] = useState("");
  const { dept } = useParams();
  const [testData, setTestData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const { addToCart, cartItems, setCartItems } = useCart();
  const [testCenters, setTestCenters] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20; // YOU CAN CHANGE
  const serviceInfo = getDepartmentInfo(dept);
  console.log("checking service info", serviceInfo);

  useEffect(() => {
    fetchTestListData();
    fetchTestCenters();
  }, []);


  const fetchTestCenters = async()=>{
    try{
      const payload={
        deptName:dept
      }
      const res = await getDepartmentWiseCenter(payload);
      console.log("centers response",res);
      setTestCenters(res?.data?.data || []);
    }catch(error){
      console.error("Error fetching test centers:", error);
    }
  }

  const fetchTestListData = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      Center_ID: "",
      search_key: "",
    };

    try {
      setLoading(true);
      const res = await getTestList(payload);

      const filterTests =
        res?.data?.data?.filter((item) => item.Package === "N") || [];

      setTestData(filterTests);
    } catch (error) {
      console.error("Error fetching test list:", error);
    } finally {
      setLoading(false);
    }
  };

  // FINAL FILTERING
  const filteredTests = testData
    ?.filter((t) => t?.Department?.toLowerCase().trim() === dept?.toLowerCase().trim())
    ?.filter((t) =>
      t?.service_name?.toLowerCase().includes(search.toLowerCase())
    );

  
  // PAGINATION LOGIC
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const paginatedTests = filteredTests.slice(indexOfFirstItem, indexOfLastItem);
  const handleView = (item) => {
    setSelectedPackage(item);
    setIsModalOpen(true);
  };
  const handleAddToCart = (packageData) => {
    if (packageData?.service_id === cartItems?.service_id) {
      toast.error("Item already in cart", { duration: 3000, id: "already-in-cart" });
    }
    addToCart({
      id: packageData.service_id,
      product: packageData?.service_name,
      price: packageData.price,
      quantity: 1,
    });
  };

    const handleToggleCart = (card) => {
      const isAdded =
      cartItems && cartItems.some((item) => item.id === card.service_id);
      if (isAdded) {
        setCartItems((prev) =>
          prev.filter((item) => item.id !== card.service_id)
        );
        toast.success("Item removed from cart", { duration: 3000, id: "item-removed" });
      } else {
        
        handleAddToCart(card);
        toast.success("Item added to cart", { duration: 3000, id: "item-added" });
      }
    };
  return (
    <div className="test-container">
      {/* <div className="breadcrumb">
        <span>Home</span> &gt; <span>Services</span> &gt;
        <span className="active-breadcrumb">{dept}</span>
      </div> */}
      <ServiceHeader
        // childClass="gastroenterologyBgSection"
        childClass={serviceInfo?.className}
        breadcrumb={
          <>
            Services <FaGreaterThan size={15} /> {serviceInfo?.title}
          </>
        }
        title={serviceInfo?.title}
      />

      <div className="header-row">
        <input
          type="text"
          className="search-input-btn"
          placeholder="Search for test and health checkup"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1); // Reset on search
          }}
        />
      </div>

      {loading && <CustomLoader />}


      {testCenters && testCenters.length > 0 && (
              <div className="centers-section">
                <h2 className="centers-heading">Centres Available</h2>
                <div className="centers-grid">
                  {testCenters.map((center, i) => (
                    <CenterCard key={i} center={center} />
                  ))}
                </div>
              </div>
            )}

      <div className="card-grid">
        {paginatedTests?.length > 0
          ? paginatedTests.map((item, i) => {
              const isAdded = cartItems && cartItems.some((cartItem) => cartItem.id === item.service_id);
              return (
              <div className="test-card" key={i}>
                <h3 className="test-title">
                  <TruncateText text={item?.service_name} maxLength={33} />
                </h3>

                {/* PRICE */}
                <span className="test-price">
                  ₹{item?.price ? parseInt(item.price) : "N/A"}
                </span>

                {/* BUTTON ROW */}
                <div className="button-row">
                  <button
                    className="view-button"
                    onClick={() => handleView(item)}
                  >
                    VIEW
                  </button>
                  <button 
                    className={`book-button ${isAdded ? "added" : ""}`}
                    onClick={() => handleToggleCart(item)}
                  >
                    <FaShoppingCart size={14} /> {isAdded ? "REMOVE" : "BOOK"}
                  </button>
                </div>
              </div>
            );
            })
          : !loading && <p className="no-test-text">No tests found</p>}
      </div>

      {/* PAGINATION */}
      {filteredTests.length > itemsPerPage && (
        <div style={{ marginTop: "1rem" }}>
          <CustomPagination
            totalPages={filteredTests.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
      <PackageDetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        packageData={selectedPackage}
      />
    </div>
  );
}
